import short from "short-uuid";
import Blob from "blob";
import saveAs from "file-saver";
import _set from "lodash.set";
import _get from "lodash.get";
import _has from "lodash.has";

import { isObject } from "@/assets/js/appFunc";

const notifyTypeSettings = {
    info: ["info", "white", "black"],
    warning: ["warning", "warning", "black"],
    error: ["error", "negative", "white"],
    success: ["check_circle", "positive", "white"]
};

const oldMappings = { positive: "success", negative: "error" };

const MyPlugin = {
    install(Vue, options) { // eslint-disable-line
        const notifyStack = {};
        Vue.prototype.$notify = function (message, type = "info", code = short.generate(), config) {
            const localType = oldMappings[type] || type;
            const [icon, color, textColor] = notifyTypeSettings[localType];
            const defaults = {
                timeout: 2000,
                message,
                type: localType,
                actions: [{
                    color: textColor, label: "", icon: "close", handler: () => notifyStack[code]()
                }]
            };
            const settings = {
                ...defaults, ...(config || {}), icon, color, textColor
            };

            if (notifyStack.hasOwnProperty(code)) {
                notifyStack[code]();
            }
            notifyStack[code] = this.$q.notify(settings);
        };

        Vue.prototype.$confirm = function (message, title = "Confirm", ok = "Yes", cancel = "Cancel") {
            return new Promise((resolve, reject) => {
                this.$q.dialog({
                    title,
                    message,
                    persistent: true,
                    ok,
                    cancel
                }).onOk(() => {
                    resolve();
                }).onCancel(() => {
                    reject();
                }).onDismiss(() => {
                    reject();
                });
            });
        };

        Vue.prototype.$generateUID = () => short.generate();
        Vue.prototype.$isObject = isObject;
        Vue.prototype.$_get = _get;
        Vue.prototype.$_set = _set;
        Vue.prototype.$_has = _has;

        Vue.prototype.$saveFileAs = function (fileName, content) {
            const blob = new Blob([content]);
            saveAs(blob, fileName);
        };

        Vue.prototype.$loadFile = file => {
            const reader = new FileReader();

            return new Promise(resolve => {
                reader.onload = () => {
                    resolve(reader.result);
                };

                reader.readAsText(file);
            });
        };

        Vue.prototype.$saveAsCSV = function (filename, content) {
            let data; let link;
            let csv = content;
            const myfile = filename || "export.csv";

            if (csv !== null) {
                if (!csv.match(/^data:text\/csv/i)) {
                    csv = `data:text/csv;charset=utf-8,${csv}`;
                }
                data = encodeURI(csv);

                link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", myfile);
                link.click();
            }
        };
        Vue.prototype.$lowerCase = function (data) {
            return typeof data === "string" ? data.toLocaleLowerCase() : undefined;
        };
    }
};

export default MyPlugin;
